import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (

<section className="main_container_block_feeds">
                                <div className="main_block_container_feed">
                                   <div className="block_container_feed_heading_text R15_61">
                                      {highlightsfeed.title}{/*<span className="dny-b-15"> Quick read   </span> for you */}
                                    </div>
                                     
                                    <div className="content-div-box-artical">
                                    <div className="view_discussion_profile_Pros">
                                        <div className="view_discussion_name_new_profile"> 
                                            <img src={highlightsfeed.data[0].userPhoto?highlightsfeed.data[0].userPhoto:''} alt="logo"/> 
                                        </div>
                                        <div className="discussion_profile_Pros"> 
                                             <div className="M15_21">{highlightsfeed.data[0].userName?highlightsfeed.data[0].userName:''}</div>
                                             <div className="post_delevery R14_9e"> {highlightsfeed.data[0].userDesc?highlightsfeed.data[0].userDesc:''}  </div>
                                        </div>
                                    </div>
                                    <div className="content-div_view_artical">
                                        <img src={highlightsfeed.data[0].urls[0].source?highlightsfeed.data[0].urls[0].source:''} alt="logo"/>
                                    </div>
                                    <div className="the_week_game_vido"> 
                                        <div className="fabulous_text"> 6 Months Old Baby Development </div>
                                        <div className="week_card-text more"> 
                                             <span className="R15_61 my_baby_question_ask"> 
                                               {highlightsfeed.data[0].discription?highlightsfeed.data[0].discription:''}
                                             </span>
                                             <a href={highlightsfeed.data?highlightsfeed.data[0].redirectionUrl:''} className="readmorelink R14_link"> Read more</a>
                                        </div>
                                    </div>
                                    
                                    <div className="profile_comments_view">
                
                                    <div className="bottom_line_divider_feed"> </div>
                                     <div className="baby-week-social-view meal_planner_healthy_social social_me_test_without_icons"> 
                                        <div className="post-options">
                                          <div className="icon left comment_icons_1"> <span className="icons-text R13_61"> {highlightsfeed.data[0].likeCount?highlightsfeed.data[0].likeCount:''} <span className='mLike'>Likes</span> </span> </div>
                                          <div className="icon left devMemoLike font-sizeview"> <span className="icons-text R13_61"> {highlightsfeed.data[0].commentCount?highlightsfeed.data[0].commentCount:''} Comments</span> </div>
                                          <div className="icon left devMemoLike comment_icons_1_font-size"> <span className="icons-text R13_61"> {highlightsfeed.data[0].participantCount?highlightsfeed.data[0].participantCount:''} Participants</span> </div>
                                          
                                        </div>
                                    </div>
                            
                                    <div className="fc_border_bottom_1"> </div>
                                     <div className="baby-week-social-view meal_planner_healthy_social mr_b4"> 
                                        <div className="post-options">

                                          <div className="icon left likesIcon" data-icon-font=""> <span className="icons-text R13_61"> Like </span> </div>
                                          <div className="icon left kids_comment_before_icons_st" data-icon-font="e"> <span className="icons-text R13_61"> Comment </span> </div>
                                          <div className="icon left m-abuse-main right"> 
                                            <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                                            <div className="icon left icon3dot whatsapp-icons" data-icon-font=""> <span className="icons-text cursor-pointer icons-text_top_meal R13_61 gtm-share"> Share </span></div>
                                          </div>
                                         
                                        </div>
                                    </div>
                                    
                                    </div>
                                 </div>
                                </div>
                            </section>

    )}
